document.addEventListener("DOMContentLoaded", function () {
  const startTourBtn = document.querySelector("#startTourBtn");
  if (!startTourBtn) return;

  startTourBtn.addEventListener("click", function () {
    console.log("🧭 Start Guided Tour clicked");

    function waitForProduktlyReady(callback, retries = 20) {
      if (window.Produktly && typeof window.Produktly.startTour === "function") {
        console.log("✅ Produktly SDK ready to start tour");
        callback();
      } else if (retries > 0) {
        console.warn("⚠️ Produktly SDK not ready yet, retrying...");
        setTimeout(() => waitForProduktlyReady(callback, retries - 1), 1000);
      } else {
        console.error("❌ Produktly SDK failed to initialize after waiting");
      }
    }

    waitForProduktlyReady(() => {
      console.log("🚀 Launching Produktly tour with ID 8203");
      window.Produktly.startTour({ tourId: "8203" });
    });
  });
});
